export default {
  data() {
    return {
      isChecked: false
    }
  },
  methods: {
    onChecked() {
      this.isChecked = !this.isChecked
    }
  }
}
